import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import { Dashboard } from "./components/dashboard";
import { Password } from "./components/password";
import { Calltoaction } from "./components/calltoaction";
import { GrowthPlan } from "./components/growthplan";
import { AccountDeletion } from "./components/accountDeletion";
import { FounderNote } from "./components/founderNote";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Signup } from "./components/signup";
import { Login } from "./components/login";
import CrewCoinPricingPage from "./components/pricing";
import FAQPage from "./components/faqPage";
import FAQWidget from "./components/faqWidget";
import SeoLandingPage from "./components/seoLandingPage";
import BlogPage from "./components/blogPage";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  function RouteSeo() {
    const location = useLocation();

    useEffect(() => {
      const seoByRoute = {
        "/": {
          title: "Crew Coin | Employee Rewards & Recognition Platform",
          description:
            "Crew Coin helps restaurants and teams boost engagement with employee rewards, recognition challenges, and redeemable perks.",
          canonical: "https://crewcoin.app/",
        },
        "/pricing": {
          title: "Crew Coin Pricing | Plans for Team Incentives",
          description:
            "Compare Crew Coin pricing plans for restaurants and multi-unit teams. Start monthly or annual billing and boost employee engagement.",
          canonical: "https://crewcoin.app/pricing",
        },
        "/account-deletion": {
          title: "Crew Coin Account Deletion",
          description:
            "Request account deletion and review the account removal process for Crew Coin.",
          canonical: "https://crewcoin.app/account-deletion",
        },
        "/signup": {
          title: "Sign Up | Crew Coin",
          description:
            "Create your Crew Coin account and start rewarding your team.",
          canonical: "https://crewcoin.app/signup",
        },
        "/login": {
          title: "Login | Crew Coin",
          description: "Access your Crew Coin dashboard.",
          canonical: "https://crewcoin.app/login",
        },
        "/forgotpassword": {
          title: "Reset Password | Crew Coin",
          description:
            "Reset your Crew Coin password and regain access to your account.",
          canonical: "https://crewcoin.app/forgotpassword",
        },
        "/faq": {
          title: "Crew Coin FAQ | Employee Incentives for Restaurant Teams",
          description:
            "Get answers about Crew Coin setup, rewards, challenges, and team incentives for restaurants.",
          canonical: "https://crewcoin.app/faq",
        },
        "/restaurant-employee-incentive-app": {
          title: "Restaurant Employee Incentive App | Crew Coin",
          description:
            "Crew Coin helps restaurant managers run effective employee incentive programs that improve engagement, reliability, and retention.",
          canonical: "https://crewcoin.app/restaurant-employee-incentive-app",
        },
        "/restaurant-employee-recognition-app": {
          title: "Restaurant Employee Recognition App | Crew Coin",
          description:
            "Recognize great work in real time with Crew Coin. Build stronger restaurant teams with daily recognition and meaningful rewards.",
          canonical: "https://crewcoin.app/restaurant-employee-recognition-app",
        },
        "/reduce-restaurant-turnover": {
          title: "How to Reduce Restaurant Turnover | Crew Coin",
          description:
            "Learn how Crew Coin helps restaurant leaders reduce turnover with better incentives, recognition habits, and manager consistency.",
          canonical: "https://crewcoin.app/reduce-restaurant-turnover",
        },
        "/blog/restaurant-employee-incentive-ideas": {
          title: "7 Employee Incentive Ideas That Actually Work in Restaurants | Crew Coin",
          description:
            "Practical restaurant employee incentive ideas to improve morale, retention, and shift performance.",
          canonical: "https://crewcoin.app/blog/restaurant-employee-incentive-ideas",
        },
        "/blog/reduce-call-offs-restaurant-recognition": {
          title: "How to Reduce Call-Offs with Better Restaurant Team Recognition | Crew Coin",
          description:
            "Learn how restaurant managers can reduce call-offs using consistent team recognition and rewards.",
          canonical: "https://crewcoin.app/blog/reduce-call-offs-restaurant-recognition",
        },
      };

      const routeSeo = seoByRoute[location.pathname] || seoByRoute["/"];
      document.title = routeSeo.title;

      const setMeta = (name, content, attr = "name") => {
        let tag = document.querySelector(`meta[${attr}="${name}"]`);
        if (!tag) {
          tag = document.createElement("meta");
          tag.setAttribute(attr, name);
          document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
      };

      const setCanonical = (href) => {
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
          link = document.createElement("link");
          link.setAttribute("rel", "canonical");
          document.head.appendChild(link);
        }
        link.setAttribute("href", href);
      };

      setMeta("description", routeSeo.description);
      setMeta("og:title", routeSeo.title, "property");
      setMeta("og:description", routeSeo.description, "property");
      setMeta("og:url", routeSeo.canonical, "property");
      setMeta("twitter:title", routeSeo.title);
      setMeta("twitter:description", routeSeo.description);
      setCanonical(routeSeo.canonical);
    }, [location.pathname]);

    return null;
  }

  function Main() {
    return (
      <>
        <Navigation />
        <Header data={landingPageData.Header} />
        <Features data={landingPageData.Features} />
        <About data={landingPageData.About} />
        <Gallery data={landingPageData.Gallery} />
        <GrowthPlan />
        <Testimonials data={landingPageData.Testimonials} />
        <Calltoaction data={landingPageData.Calltoaction} />
        <FounderNote />
        <Contact data={landingPageData.Contact} />
      </>
    )
  }

  return (
    <div>
      <Router>
        <RouteSeo />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/pricing" element={<CrewCoinPricingPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/forgotpassword" element={<Password />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
          <Route
            path="/restaurant-employee-incentive-app"
            element={<SeoLandingPage
              title="Employee Incentives Made Simple"
              subtitle="Employee incentive app for teams across industries"
              intro="Crew Coin helps leaders reward consistency, teamwork, and performance. Create incentives, recognize wins, and keep your staff engaged every day."
              ctaText="Book a Demo"
              sections={[
                { heading: "Why Teams Need Better Incentives", body: "Fast-moving workplaces depend on reliable execution. Consistent incentives help reinforce punctuality, accountability, and teamwork in ways annual reviews never can." },
                { heading: "How Crew Coin Works", body: "Managers define the behaviors they want more of, recognize employees with coins, and allow staff to redeem points for rewards that matter. The process is simple enough to run daily." },
                { heading: "Rewards Your Staff Actually Wants", body: "From practical perks to fun team rewards, Crew Coin helps leaders match incentives to what motivates their people—without overcomplicating operations." },
                { heading: "Designed for Frontline Operations", body: "Whether your teams are in retail, manufacturing, hospitality, or service environments, Crew Coin creates consistent incentive habits that improve performance." },
                { heading: "Start Your Crew Coin Pilot", body: "Launch in days, not months. Start with one team, prove engagement gains, then roll out broadly." },
              ]}
            />}
          />
          <Route
            path="/restaurant-employee-recognition-app"
            element={<SeoLandingPage
              title="Recognize Great Work in Real Time"
              subtitle="Employee recognition app for frontline teams"
              intro="Crew Coin helps managers and teams celebrate wins daily, not just during annual reviews. Reinforce the behaviors that matter and build a stronger culture day by day."
              ctaText="Schedule a Demo"
              sections={[
                { heading: "Why Recognition Improves Retention", body: "Employees who feel seen are more likely to stay engaged and committed. Frequent recognition builds momentum and reduces the risk of burnout and turnover." },
                { heading: "Peer + Manager Recognition in One Place", body: "Crew Coin combines manager-led incentives with team-level recognition, helping everyone reinforce standards and celebrate progress together." },
                { heading: "Turn Recognition Into Meaningful Rewards", body: "Recognition is strongest when it connects to tangible outcomes. Crew Coin ties wins to redeemable rewards so positive behavior keeps compounding." },
                { heading: "Recognition for Single and Multi-Location Teams", body: "Create consistency in how praise is given across every store while still allowing each manager to spotlight what matters most for their team." },
                { heading: "See Crew Coin in Action", body: "Book a short walkthrough to see how Crew Coin fits into your existing routines and helps your team perform at a higher level." },
              ]}
            />}
          />
          <Route
            path="/reduce-restaurant-turnover"
            element={<SeoLandingPage
              title="Reduce Turnover with Better Incentives"
              subtitle="A practical retention playbook for frontline leaders"
              intro="High turnover hurts consistency, morale, and profit. Crew Coin helps leaders motivate employees with consistent recognition and rewards that keep top performers engaged."
              ctaText="Start a Pilot"
              sections={[
                { heading: "The Real Cost of Turnover", body: "Replacing employees costs time, training effort, and output quality. Even small improvements in retention can create major operational wins." },
                { heading: "What Actually Keeps Staff Engaged", body: "Clear expectations, fair recognition, and immediate positive reinforcement drive stronger daily behavior than occasional top-down communication." },
                { heading: "How Crew Coin Supports Retention", body: "Crew Coin helps managers reinforce reliability, teamwork, and service quality with consistent incentives staff can understand and trust." },
                { heading: "Simple 30-Day Pilot for Restaurant Teams", body: "Start with one location, choose a few core behaviors, and track engagement improvements over four weeks before scaling." },
                { heading: "Book a Demo", body: "See how Crew Coin can support your retention goals and give your managers practical tools to motivate teams." },
              ]}
            />}
          />
          <Route
            path="/blog/restaurant-employee-incentive-ideas"
            element={<BlogPage
              title="7 Employee Incentive Ideas That Actually Work in Restaurants"
              intro="If you want better consistency, attendance, and energy on shift, incentives have to be clear, fair, and frequent. Here are seven ideas restaurant teams actually use."
              sections={[
                { heading: "1) Reliability streak rewards", body: "Reward 2-4 week streaks of on-time attendance and completed shifts to reinforce dependable habits." },
                { heading: "2) Guest feedback shout-outs", body: "Tie positive guest feedback to recognition points so service excellence gets reinforced in real time." },
                { heading: "3) Teamwork bonus moments", body: "Recognize employees who step in to help during rushes, cover shifts, or coach teammates." },
                { heading: "4) Upsell and quality incentives", body: "Reward both sales behavior and execution quality to avoid pushing one metric at the expense of guest experience." },
                { heading: "5) Speed + accuracy wins", body: "Celebrate teams that improve ticket times while maintaining quality standards." },
                { heading: "6) Milestone recognition", body: "Use 30/60/90-day milestones and anniversaries to reduce early attrition and show growth paths." },
                { heading: "7) Monthly challenge themes", body: "Rotate challenge themes (hospitality, teamwork, reliability) to keep engagement fresh and aligned with business goals." },
              ]}
            />}
          />
          <Route
            path="/blog/reduce-call-offs-restaurant-recognition"
            element={<BlogPage
              title="How to Reduce Call-Offs with Better Restaurant Team Recognition"
              intro="Call-offs are often treated as a scheduling issue, but they are usually a motivation and accountability issue too. Recognition can help shift behavior fast."
              sections={[
                { heading: "Reward reliability behaviors", body: "Focus on the behaviors you want more of: on-time arrival, early coverage notice, and responsible swaps." },
                { heading: "Use weekly manager recognition cadence", body: "Short weekly recognition keeps expectations visible and reinforces consistency without adding admin burden." },
                { heading: "Keep rewards meaningful but simple", body: "Small practical rewards can outperform expensive perks when they are frequent and tied to clear actions." },
                { heading: "Track outcomes for 30 days", body: "Measure call-offs, tardiness, and manager sentiment before and after rollout so you can prove what is working." },
                { heading: "Scale what works", body: "Start with one location, lock in a repeatable routine, then roll out to additional stores with the same framework." },
              ]}
            />}
          />
        </Routes>
        <FAQWidget />
      </Router>
    </div>
  );
};

export default App;
